<template>
  <div class="competition-details-filter-container" v-if="!loading">
    <b-row v-for="condition in this.requirementFilters[0].conditions" :key="condition">
      <b-col md="12" class="condition-container">
        <b-col class="mb-3" md="12">
          <strong>{{ getReadableName(Object.keys(condition)[0]) }}</strong>
        </b-col>
        <b-col class="mb-3" md="12">{{
          getReadableBaseLogic(getLogic(Object.values(Object.values(condition)[0])[1]))
        }}</b-col>
        <b-col class="mb-3" md="12">{{
          getReadableInnerOperator(
            Object.keys(condition)[0],
            getOperator(Object.values(Object.values(condition)[0])[1])
          )
        }}</b-col>

        <b-col md="12" v-if="Object.keys(condition)[0] === 'restrictedCompetitions'">
          {{ getRestrictedCompetitionNames(Object.values(Object.values(condition)[0])[1]) }}
        </b-col>
        <b-col v-else md="12">{{ getOperands(Object.values(Object.values(condition)[0])[1]) }}</b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { LOGIC_OPERATOR } from '../models/logicOperator'
import { getCompanyFieldFormTemplates } from '../../../api/company'
import { getReadableOperator } from '../models/operator'

export default {
  props: ['requirementFilters'],
  name: 'CompetitionFilter',
  data: function() {
    return {
      fieldForms: [],
      loading: true,
      restrictedCompetitionNames: []
    }
  },
  created: async function() {
    const fieldForms = await getCompanyFieldFormTemplates()
    this.fieldForms = fieldForms
    this.loading = false
  },
  computed: {
    keys: function() {
      const result = this.requirementFilters[0].conditions.map(x => {
        return Object.keys(x)
      })
      return result
    }
  },
  methods: {
    getReadableName(key) {
      const fieldForm = this.fieldForms.filter(ff => ff.field === key)[0]
      return fieldForm.title
    },
    getReadableBaseLogic(logic) {
      switch (logic) {
        case LOGIC_OPERATOR.AND:
          return 'Minden feltételnek teljesülnie kell'
        case LOGIC_OPERATOR.OR:
          return 'Legalább egy feltételnek teljesülnie kell'
      }
    },
    getReadableInnerOperator(key, operator) {
      const fieldForm = this.fieldForms.filter(ff => ff.field === key)

      if (fieldForm[0].allowedOperators !== undefined) {
        const stringOperator = fieldForm[0].allowedOperators.filter(allowedOperator => {
          allowedOperator.action === operator
        }).friendlyNameOfAction
        if (!stringOperator) {
          return getReadableOperator(operator)
        } else {
          return stringOperator
        }
      } else {
        return ''
      }
    },
    getOperands(value) {
      if (value[0].operands[0] === true) {
        return 'Igaz'
      }
      let result = ''
      value[0].operands.forEach(x => {
        result += ', ' + x
      })
      return result.slice(2)
    },
    getOperator(value) {
      return value[0].operator
    },
    getLogic(value) {
      return value[0].logic
    },
    getRestrictedCompetitionNames(value) {
      return value[0].operands.length + ' kizáró pályázattal rendelkezik.'
    }
  }
}
</script>

<style scoped>
strong {
  color: black;
  text-align: left;
}
.competition-details-filter-container {
  width: 100%;
}
div {
  text-align: left;
}
p {
  text-align: left;
}
.condition-container {
  border-bottom: 1px solid lightgray;
  margin-top: 15px;
  padding: 0;
}
</style>
